import * as React from 'react';
import { isNil } from 'ramda';

import { scrollingContext } from '../context';
import { EScrollingBlocks } from '../../../constants/scrollingBlocks';

/**
 * Утилита возвращает bool, отрендерился ли блок scrollingBlock на экране
 * Если блок рендирится, значит на него должна быть рефка в refBlocksState.
 * */
export const useScrollingBlockVisible = (scrollingBlock: EScrollingBlocks): boolean => {
  const { refBlocksState } = React.useContext(scrollingContext);

  return !isNil(refBlocksState[scrollingBlock]?.ref.current);
};
